import { ReportInterface } from '../../../../stateManagement/redux/slices/gerencia_tecnica/interfaces'
import React, { useEffect, useMemo, useState } from 'react'
import { Box, Button } from '@mui/material';
import { MaterialReactTable, useMaterialReactTable, type MRT_ColumnDef } from 'material-react-table'
import { selectGtoState, useDispatch } from "../../../../stateManagement/redux"
import { getReportWithData } from '../../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers';
import { useSelector } from 'react-redux';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

export const DynamicDataGridTable = ({ report, filters }: { report: ReportInterface, filters: any }) => {

  const dispatch = useDispatch();

  const mainState = useSelector(selectGtoState);

  const [data, setData] = useState<any[]>([])
  const [headers, setHeaders] = useState<any[]>([])

  useMemo<any>(() => {

    const headers: any[] = []

    const data: any[] = []

    let count = 0;

    mainState.reportWithData?.forEach((row: any) => {
      data.push({
        id: count + 1,
        ...row
      })
      count++;
    })

    if (data) {

      setData(data)

      try {
        Object.keys(data[0]).map((key) => {
          headers.push({
            field: key,
            headerName: key,
            headerClassName:'super-app-theme--header'
          })
        })

      } catch (error) { }
    }
    setHeaders(headers)
  }, [mainState.reportWithData])

  return (
    <Box className='dynamic_table_container' sx={{ height: '80vh' }}>
      <DataGrid
      rows={data}
      columns={headers}
      initialState={{ pagination: { paginationModel: { page: 0, pageSize: 10 } } }}
      pageSizeOptions={[10, 20, 50, 100]}
      checkboxSelection={false}
      sx={{ 
      border: 0, 
      '& .MuiDataGrid-columnHeaders': { 
      position: 'sticky', 
      top: 0, 
      zIndex: 1,
      },
      '& .super-app-theme--header': {
        backgroundColor: '#316EBC',
        color: 'white',
      },
      }}
      onRowClick={() => { }}
      />
    </Box>
  )
}
